(function () {
  function initToggle(button) {
    var section = button.closest('.product-picker-grid');
    if (!section) return;

    var grid = section.querySelector('[data-product-grid]');
    var label = button.querySelector('[data-toggle-label]');
    var hiddenCards = grid
      ? Array.prototype.slice.call(
          grid.querySelectorAll('.product-picker-grid__card--hidden')
        )
      : [];

    var expandText = label ? label.textContent : '';
    var collapseText =
      section.getAttribute('data-collapse-text') || 'Voir moins';

    var isExpanded = false;

    button.addEventListener('click', function () {
      isExpanded = !isExpanded;

      hiddenCards.forEach(function (card) {
        card.classList.toggle('product-picker-grid__card--hidden', !isExpanded);
      });

      button.setAttribute('aria-expanded', String(isExpanded));
      if (label) {
        label.textContent = isExpanded ? collapseText : expandText;
      }

      if (!isExpanded) {
        // Repli : remonte confortablement vers le haut de la grille plutôt
        // que de laisser l'utilisateur en bas d'une page qui vient de rétrécir.
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  function initAll() {
    var buttons = document.querySelectorAll('[data-product-grid-toggle]');
    buttons.forEach(initToggle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();